// Список роутов зарегистрированных в shared-ui, доступные клиентам из категории "Банк для Банков"
// С помощью этого списка скрываются пункты меню и происходит редирект на главную страницу при регистрации React роутов.
export const BANK_FOR_BANKS_ROUTES = [
  "/login",
  "/profile",
  "/messages",
  "/statements",
  "/main/accounts",
  "/counterparties",
  "/foreign-activity/new",
  "/swift-messages",
];
